const freeShippingThreshold = 50;

const cartAddedObserver = new MutationObserver((mutations) => {
	if (mutations.some(mutation => mutation.addedNodes?.length)) {
		const cartNode = document.querySelector<HTMLElement>('form.cart');
		if (!cartNode) {
			return;
		}

		const updateShippingMessage = () => {
			const moneyNode = document.querySelector<HTMLElement>('.ajaxcart__footer-total .money');
			if (!moneyNode) {
				return;
			}
			
			const currentTotal = parseFloat(moneyNode.innerText.replace(/[^0-9.-]+/g, ""));
			const difference = freeShippingThreshold - currentTotal;
			const qualifyFreeShipping = document.querySelector<HTMLElement>('.qualify-free-shipping');
			if (!qualifyFreeShipping) {
				return;
			}

			let newText;
			if (difference > 0) {
				newText = `You are $${difference.toFixed(2)} away from free shipping!`; // Update the emphasize copy with the difference
			} else {
				newText = "You qualify for free shipping!"; // Update the emphasize copy with the free shipping message
			}

			if (qualifyFreeShipping.textContent !== newText) {
				// Only cause a change (aka a mutation) if there is an update to be made
				qualifyFreeShipping.textContent = newText;
			}

		};
		updateShippingMessage();
		new MutationObserver(() => updateShippingMessage()).observe(cartNode, { subtree: true, childList: true });

		cartAddedObserver.disconnect();
	}
});
cartAddedObserver.observe(document, { subtree: true, childList: true });